// extracted by mini-css-extract-plugin
module.exports = {"Caret__icon":"Caret__icon__kiTA1"};